export default __webpack_public_path__ + "static/cpd-logo-797dc4eac80dd8ddea2dc5d3247c28c3.svg";